export const capitalizeLetters = (str: string) => {
  var pieces = str.split(' ')
  for (var i = 0; i < pieces.length; i++) {
    var j = pieces[i].charAt(0).toUpperCase()
    pieces[i] = j + pieces[i].substring(1)
  }
  return pieces.join(' ')
}
